import { exportResponseHandler } from "../../helpers/downloads";
import { wealthProApi } from "../../redux/api";
import { useCacheKeyMergeHandler, useCacheKeySerializeQueryArgsHandler, useCacheKeyTransformResponseHandler } from "../../redux/helpers";

const hoAdminReportingApiEndpoints = wealthProApi.enhanceEndpoints({
    //addTagTypes: ['adminReports']
}).injectEndpoints({
    endpoints: (builder) => ({
        fetchAdminReports: builder.query({
            query: ({ page = 1, limit = 50, sort = "ReportType" }) => `api/headofficeadmin/reporting/reporting?page=${page}&limit=${limit}&sort=${sort}`
                //providesTags: (result, error, arg) => {
                    //return ['adminReports'];
                //}
        }),  
        fetchAdviserLeagueTable: builder.query({
            query: ( {data} ) => ({
                url: `api/headofficeadmin/managementreports/adviserleaguetable`,
                method: "POST",
                body: data
            }),
        }), 

        detailedLeagueTable: builder.query({
            query: ({ data }) => ({
                url: `api/headofficeadmin/managementreports/detailedleaguetable`,
                method: "POST",
                body: data
            }),
        }),
        ajbDebtorsLedgerReport: builder.query({
            query: ({ data }) => ({
                url: `api/headofficeadmin/accountingreports/ajbdebtorsledgerreport`,
                method: "POST",
                body: data
            }),
        }),
        debtorsLedgerReport: builder.query({
            query: ({ data }) => ({
                url: `api/headofficeadmin/accountingreports/debtorsledgerreport`,
                method: "POST",
                body: data
            }),
        }),
        ajbServiceFeesBilledReport: builder.query({
            query: ({ data }) => ({
                url: `api/headofficeadmin/accountingreports/ajbservicefeesbilledreport`,
                method: "POST",
                body: data
            }),
        }),
        businessStatusReport: builder.query({
            query: ({ data }) => ({
                url: `api/headofficeadmin/managementreports/businessstatusreport`,
                method: "POST",
                body: data
            }),
        }),
        reviewsInProgressReport: builder.query({
            query: ({ data }) => ({
                url: `api/headofficeadmin/managementreports/reviewsinprogressreport`,
                method: "POST",
                body: data
            }),
        }),
        
        contactStatisticsReport: builder.query({
            query: ({ data }) => ({
                url: `api/headofficeadmin/managementreports/contactstatisticsreport`,
                method: "POST",
                body: data
            }),
        }),
        newMoneyReport: builder.query({
            query: ({ data }) => ({
                url: `api/headofficeadmin/managementreports/newmoneyreport`,
                method: "POST",
                body: data
            }),
        }),
        newBusinessForecastReport: builder.query({
            query: ({ data }) => ({
                url: `api/headofficeadmin/managementreports/newbusinessforecastreport`,
                method: "POST",
                body: data
            }),
        }),
        fetchNewBusinessRegister: builder.query({
            query: ({ cacheKey, ...body }) => ({
                url: `api/headofficeadmin/managementreports/newbusinessregister`,
                method: 'POST',
                body
            }),
            transformResponse: useCacheKeyTransformResponseHandler,
            serializeQueryArgs: useCacheKeySerializeQueryArgsHandler,
            merge: useCacheKeyMergeHandler
        }),
        exportNewBusinessRegister: builder.query({
            query: (body) => ({
                url: `api/headofficeadmin/managementreports/newbusinessregister/export`,
                method: 'POST',
                body,
                responseHandler: exportResponseHandler("New Business Register.csv"),
                cache: 'no-cache'
            })
        })
    })
});

export const {
    useFetchAdminReportsQuery,
    useLazyFetchAdminReportsQuery,
    useLazyDetailedLeagueTableQuery,
    useLazyAjbDebtorsLedgerReportQuery,
    useLazyDebtorsLedgerReportQuery,
    useLazyAjbServiceFeesBilledReportQuery,
    useLazyBusinessStatusReportQuery,
    useLazyReviewsInProgressReportQuery,
    useLazyContactStatisticsReportQuery,
    useLazyNewMoneyReportQuery,
    useLazyNewBusinessForecastReportQuery,
    useFetchAdviserLeagueTableQuery,
    useLazyFetchAdviserLeagueTableQuery,
    useLazyFetchNewBusinessRegisterQuery,
    useLazyExportNewBusinessRegisterQuery
} = hoAdminReportingApiEndpoints;